import styled from 'styled-components';

export const ModalOverlay = styled.div`
  .hefesto-modal__container {
    width: 368px;
  }
  .hefesto-modal__header {
    margin-bottom: 12px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #495961;
      font-weight: 400;
    }
  }
  .hefesto-modal__body {
    font-size: 16px;
    line-height: 24px;
    color: #414e55;
    font-weight: 600x;
  }
`;
